module.exports = __webpack_public_path__ + "img/benefits-12.cf5f8587.svg";